module.exports = __webpack_public_path__ + "static/media/bt.e502aa33.svg";